/* eslint-disable */
import cloneDeep from 'lodash/cloneDeep';
import { Message } from 'element-ui';
import router from './router'
import store from './store'
import types from './store/types';
import { removeToken, getToken } from '@/utils/auth';
import { Base64 } from './utils/base64';
import Cookies from 'js-cookie';

router.beforeEach((to, from, next) => {
  if(getToken()) {
    if(['/login', '/webadmin', '/403'].includes(to.path)) {
      next('/');
    } else if (!store.state.base.roleIds.length) {
      if(!!store.state.base.userInfo.id) {
        Message.error('此账号权限不足');
        store.commit(types.CLEAR_LOGININFO);
        removeToken();
        next('/login');
      } else {
        store.dispatch('loginByToken')
          .then(e => {
            const accessedRouters = cloneDeep(store.state.base.routers);
            router.resetRouter(accessedRouters);
            next({
              ...to,
              replace: true
            });
          })
          .catch(() => {
            store.commit(types.CLEAR_LOGININFO);
            removeToken();
            next('/login');
          })
      }
      next();
    } else {
      next();
    }
  } else if(['/login', '/webadmin', '/403'].includes(to.path)) {
    next();
  } else if (to.path === '/home' && to.query.token) {
    const token = Base64.decode(to.query.token);
    if (token.search('.login') !== -1) {
      const newToken = token.slice(0, -6);
      Cookies.set('Token', newToken);
      next();
      store.dispatch('loginByToken')
        .then(e => {
          const accessedRouters = cloneDeep(store.state.base.routers);
          router.resetRouter(accessedRouters);
          next({
            ...to,
            replace: true
          });
        })
        .catch(() => {
          store.commit(types.CLEAR_LOGININFO);
          removeToken();
          next('/403');
        })
    } else {
      next('/403');
    }
  } else {
    store.commit(types.CLEAR_LOGININFO);
    removeToken();
    next('/login');
  }
});



// WEBPACK FOOTER //
// ./src/permission.js